import { render, staticRenderFns } from "./GoogleWorkspaceInvoiceCapture.vue?vue&type=template&id=715a2fa5&scoped=true&"
import script from "./GoogleWorkspaceInvoiceCapture.vue?vue&type=script&lang=js&"
export * from "./GoogleWorkspaceInvoiceCapture.vue?vue&type=script&lang=js&"
import style0 from "./GoogleWorkspaceInvoiceCapture.vue?vue&type=style&index=0&id=715a2fa5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a2fa5",
  null
  
)

export default component.exports